export default __webpack_public_path__ + "static/media/COVIDMAP.d048b53d.png";